import { Component } from 'react';

import { twclsx } from 'utils/twclsx';

interface DateTagComponentProps {
    className?: string;
    active?: boolean;
    children?: string | JSX.Element | JSX.Element[];
}

class DateTag extends Component<DateTagComponentProps> {
    render() {
        const { className, children, active } = this.props;

        return (
            <div
                className={twclsx(
                    'date',
                    'px-1',
                    'py-1',
                    'text-sm',
                    'font-medium',
                    'rounded-full',
                    `${active ? 'border' : 'hide-border'}`,
                    'items-center',
                    'justifys-center',
                    'font-medium',
                    'leading-3',
                    'cursor-pointer',
                    'flex',
                    'flex-row',
                    'capitalize',
                    'inline-flex',
                    'font-medium',
                    'leading-4',
                    className
                )}
            >
                {children}
            </div>
        );
    }
}

export default DateTag;
